interface Props {
	width?: string;
	height?: string;
}
const MoneyIcon = ({ width = '27', height = '26' }: Props) => (
	<svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 27 26" fill="none">
		<g opacity="0.6">
			<path
				d="M25.5786 12.9988C25.5786 19.67 20.1701 25.0766 13.5016 25.0766C6.83313 25.0766 1.42139 19.6716 1.42139 12.9988C1.42139 6.32592 6.82994 0.920898 13.5016 0.920898C20.1733 0.920898 25.5786 6.32752 25.5786 12.9988Z"
				fill="#FACC15"
			/>
			<path
				d="M8.28464 12.1253H8.7094L8.35171 10.1805C8.22875 9.49865 8.49702 9.01802 9.04474 8.9286C9.61482 8.83919 10.0843 9.05155 10.1961 9.73337L10.5761 12.1253H11.7275L12.2864 9.75572C12.4429 9.07391 13.0241 8.90625 13.4377 8.90625C13.8513 8.90625 14.4325 9.07391 14.589 9.75572L15.1367 12.1253H16.2993L16.6793 9.73337C16.7911 9.05155 17.2606 8.83919 17.8306 8.9286C18.3672 9.01802 18.6355 9.49865 18.5125 10.1693L18.1436 12.1253H18.5796C19.0826 12.1253 19.2614 12.4271 19.2614 12.7624C19.2614 13.0977 19.0714 13.4331 18.5796 13.4331H17.9089L17.2941 16.7862C17.1711 17.4569 16.6681 17.8593 16.1651 17.904C15.6286 17.9487 15.0138 17.7251 14.8349 16.9874L14.0301 13.4331H12.8453L12.0404 16.9874C11.8616 17.7251 11.2468 17.9487 10.7103 17.904C10.2073 17.8593 9.70424 17.4569 9.58129 16.7862L8.95532 13.4331H8.28464C7.79281 13.4331 7.60278 13.0977 7.60278 12.7624C7.60278 12.4271 7.78163 12.1253 8.28464 12.1253ZM11.0456 15.0873L11.4257 13.4331H10.7773L11.0456 15.0873ZM13.1359 12.1253H13.7283L13.4377 10.8064L13.1359 12.1253ZM15.8298 15.0761L16.0869 13.4331H15.4386L15.8298 15.0761Z"
				fill="white"
			/>
		</g>
	</svg>
);

export default MoneyIcon;
